import { Link } from "react-router-dom";

import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";

// images
import saas1 from "../../assets/images/hero/dashboard.png";
import saas2 from "../../assets/images/hero/resources.png";
import saas3 from "../../assets/images/hero/jobs.png";

const SwiperSlider1 = () => {
  const swiperConfig = {
    slidesPerView: 1,
    loop: true,
    spaceBetween: 0,
    autoplay: {
      delay: 5000,
    },
    breakpoints: {
      576: { slidesPerView: 1.2 },
      768: { slidesPerView: 1 },
    },
    roundLengths: true,
  };

  // Image info for SEO and hover tooltips
  const imageInfo = [
    {
      alt: "TINT dashboard interface showing project management and analytics overview",
      title: "Project Dashboard"
    },
    {
      alt: "TINT resources page displaying various categories and available resources",
      title: "Resources Library"
    },
    {
      alt: "TINT jobs board showing available opportunities and career listings",
      title: "Jobs Board"
    }
  ];

  return (
    <Swiper modules={[Autoplay]} {...swiperConfig}>
      {[saas1, saas2, saas3].map((img, index) => (
        <SwiperSlide key={index.toString()}>
          <div className="swiper-slide-content">
            {/* <div className="video-overlay d-flex align-items-center justify-content-center">
              <Link to="#" className="btn-play success"></Link>
            </div> */}
            <img 
              src={img} 
              alt={imageInfo[index].alt} 
              title={imageInfo[index].title}
              className="img-fluid rounded-lg" 
            />
          </div>
        </SwiperSlide>
      ))}
    </Swiper>
  );
};

export default SwiperSlider1;
